import styles from "./taskfilter.module.css";
import { Link } from "react-router-dom";
import { ArrowRight, Filter, Plus, Search } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import FilterAutocomplete from "../../../components/FilterAutocomplete";

const STATUS_OPTIONS = [
  { value: "active", label: "Active" },
  { value: "disabled", label: "Disabled" },
];

const TaskFilter = ({ setFilterData, setAddTaskModalOpen, filterData, setPage, propertyList, technicianList }) => {
  const { user, isAuthenticated } = useAuth0();
  const [showFilter, setShowFilter] = useState(false);

  const changeFilter = (key, value) => {
    setFilterData((prev) => ({ ...prev, [key]: value }));
    setPage(0);
  };

  return (<div className={`${styles.SearchFilterSec}`}>
    <div className={`${styles.SearchCon}`}>
      <div className={`${styles.SearchConSec}`}>
        <Search />
        <input type="text" placeholder="Search" value={filterData?.searchKey} onChange={(e) => changeFilter("searchKey", e.target.value)} />
      </div>
    </div>
    <div className={`${styles.FilterSec}`}>
      <div className={!showFilter ? `${styles.FilterFieldSec}` : `${styles.FilterFieldSec} ${styles.Open}`}>
        <p className={`${styles.FilterTitle}`}>
          Filters
          <span onClick={(e) => setShowFilter(false)}>
            <ArrowRight />
          </span>
        </p>
        <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Property"
            options={propertyList}
            value={filterData?.property}
            onChange={(value) => changeFilter("property", value)}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="User"
            options={technicianList}
            value={filterData?.technician}
            onChange={(value) => changeFilter("technician", value)}
          />
        </div>
        <div className={`${styles.FilterCard} ${styles.Select} CusSelectFilter Filter`}>
          <FilterAutocomplete
            label="Status"
            options={STATUS_OPTIONS}
            value={filterData?.status}
            onChange={(value) => changeFilter("status", value)}
          />
        </div>
      </div>
      <Link className={`${styles.FilterBu}`} onClick={(e) => setShowFilter(true)}>
        <Filter />
      </Link>
      {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("task:create") > -1 && <Link onClick={(e) => setAddTaskModalOpen(true)} className={`${styles.AddNoteBu}`}>
        <Plus /> <span>Task List</span>
      </Link>}
    </div>
  </div>);
};

export default TaskFilter;
